import React, { Component } from 'react';

import { Button, Icon } from 'semantic-ui-react';

import Rnd from 'react-rnd';
import ReactCursorPosition from 'react-cursor-position';
import { ElementPan } from 'react-element-pan-ts';

import MapPoint from './MapPoint';
import CloseButton from './CloseButton';
import Legend from './Legend';

export default class MiniMap extends Component {
  state = {
    width: 500,
    height: 300,
    x: 0,
    y: 0,
    zoom: 1,
    minimized: false,
    panPosition: { x: 100, y: 100 }
  };
  constructor(props) {
    super(props);

    styles.container.bottom += this.state.height;

    this.state.zoom = this.props.data.debugMode
      ? 1
      : this.props.data.defaultZoomLevel || 1;

    this.populateMapPoints = this.populateMapPoints.bind(this);
    this.handleMousePositionChange = this.handleMousePositionChange.bind(this);
    this.zoom = this.zoom.bind(this);
    this.renderMinimized = this.renderMinimized.bind(this);
    this.renderUnminimized = this.renderUnminimized.bind(this);
  }

  populateMapPoints(mapPoints) {
    return mapPoints.map((point, index) => {
      const selected =
        JSON.stringify(point) == JSON.stringify(this.props.currentMap);
      return (
        <MapPoint
          key={`map-point-${index}`}
          index={index}
          pointData={point}
          onClick={this.props.onPointSelect}
          selected={selected}
        />
      );
    });
  }

  handleMousePositionChange(data) {
    // console.log(data);
    data.minimapState = { ...this.state };
    this.props.onMouseMove(data);
  }

  zoom(amount) {
    const zoom = this.state.zoom * amount;
    this.setState({ zoom });
  }

  // These aren't very DRY. I'll have to fix it later.
  renderMinimized() {
    return (
      <div style={styles.container}>
        <Rnd
          enableResizing={false}
          dragHandleClassName="handle"
          style={styles.rnd}
          size={{ width: this.state.width, height: 35 }}
          position={{ x: this.state.x, y: this.state.y }}
          onDragStop={(e, d) => {
            this.setState({ x: d.x, y: d.y });
          }}
          minWidth={this.props.minWidth}
          maxWidth={3000}
          onResize={(e, direction, ref, delta, position) => {
            this.setState({
              width: ref.offsetWidth,
              height: ref.offsetHeight,
              ...position
            });
          }}
        >
          <h4 className="handle" style={styles.header}>
            {this.props.currentMap.title}
            <MinimizeButton
              minimized={true}
              onClick={() =>
                this.setState({ minimized: !this.state.minimized })
              }
            />
            <CloseButton onClick={() => this.props.onClose()} />
          </h4>
        </Rnd>
      </div>
    );
  }

  renderUnminimized() {
    const { data } = this.props;
    return (
      <div style={styles.container}>
        <Rnd
          lockAspectRatio
          dragHandleClassName="handle"
          style={styles.rnd}
          size={{ width: this.state.width, height: this.state.height }}
          position={{ x: this.state.x, y: this.state.y }}
          onDragStop={(e, d) => {
            this.setState({ x: d.x, y: d.y });
          }}
          minWidth={this.props.minWidth}
          minHeight={200}
          maxWidth={3000}
          maxHeight={700}
          onResize={(e, direction, ref, delta, position) => {
            this.setState({
              width: ref.offsetWidth,
              height: ref.offsetHeight,
              ...position
            });
          }}
        >
          <h4 className="handle" style={styles.header}>
            {this.props.currentMap.title}
            <MinimizeButton
              onClick={() =>
                this.setState({ minimized: !this.state.minimized })
              }
            />
            <CloseButton onClick={() => this.props.onClose()} />
          </h4>
          <ElementPan
            style={{
              position: 'absolute',
              minWidth: this.state.panPosition.x,
              minHeight: this.state.panPosition.y,
              visible: !this.state.minimized
            }}
            width={this.state.width}
            height={this.state.height}
            onPan={panPosition => this.setState({ panPosition })}
            startX={this.state.panPosition.x}
            startY={this.state.panPosition.y}
          >
            {/* Legend */}
            <Legend
              style={{
                display: 'inline',
                position: 'fixed',
                bottom: 0,
                left: 0,
                zIndex: 1
              }}
            />
            {/* track cursor position change */}
            <ReactCursorPosition
              // style={{ ...styles.img, width: `${100 * (this.state.zoom || 1)}%` }}
              style={{
                ...styles.img,
                // transform: `scale(${this.state.zoom})`,
                width: this.state.width * this.state.zoom,
                height: this.state.height * this.state.zoom,
                padding: 10
              }}
              onPositionChanged={this.handleMousePositionChange}
            >
              {/* The actual map image */}
              <img
                src={data.minimapImage}
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: 'auto'
                }}
                onDragStart={e => {
                  e.preventDefault();
                  return false;
                }}
              />
              {this.populateMapPoints(data.maps)}
            </ReactCursorPosition>
          </ElementPan>
          <div style={{ position: 'absolute', bottom: 15, right: 15 }}>
            <Button icon="zoom in" onClick={() => this.zoom(1.25)} />
            <Button icon="zoom out" onClick={() => this.zoom(0.75)} />
          </div>
        </Rnd>
      </div>
    );
  }

  render() {
    if (!this.props.visible) {
      return <div />;
    }
    return (
      <div>
        {this.state.minimized && this.renderMinimized()}
        {!this.state.minimized && this.renderUnminimized()}
      </div>
    );
  }
}

const MinimizeButton = props => {
  const text = props.minimized ? '+' : '–';
  return (
    <Button basic style={styles.minimizeButton} onClick={props.onClick}>
      {text}
    </Button>
  );
};

const styles = {
  container: { position: 'absolute', bottom: 160, left: 10 },
  rnd: {
    background: 'white',
    // border: '1px solid #343434',
    boxShadow: '1px 1px 8px #343434',
    borderRadius: 7,
    // padding: 10,
    // paddingTop: 30,
    overflow: 'hidden'
  },
  img: {
    position: 'absolute',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    width: '100%',
    height: 'auto'
  },
  header: {
    position: 'absolute',
    left: 0,
    top: -3,
    zIndex: 100,
    textAlign: 'center',
    width: '100%',
    background: '#dedede',
    boxShadow: '0px 0px 10px 3px #343434aa',
    color: '#343434',
    marginTop: 0,
    padding: 3,
    paddingTop: 8,
    marginBottom: 5,
    cursor: 'hand'
  },
  minimizeButton: {
    float: 'right',
    paddingTop: 5,
    paddingBottom: 5,
    color: '#000'
  }
};



// WEBPACK FOOTER //
// ./src/components/MiniMap.js